<template>
    <el-row>
        <el-col :span="colspan">
            <el-tabs :closable="tabs.length>1" v-model="activeName" @tab-remove="handleRemove" @tab-click="handleClick">
                <el-tab-pane v-for="item in tabs"
                             :key="item.name"
                             :label="item.label"
                             :name="item.name">
                </el-tab-pane>
            </el-tabs>
        </el-col>
        <el-col :span="2" class="el-tabs__nav-wrap" v-if="tabs.length>1" style="text-align: right;">
            <el-dropdown @command="handleCommand" placement="bottom">
                <span class="el-dropdown-link" style="height: 40px;line-height: 40px;">
                    更多<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="else">关闭其他</el-dropdown-item>
                    <el-dropdown-item command="left">关闭左侧所有</el-dropdown-item>
                    <el-dropdown-item command="right">关闭右侧所有</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </el-col>
    </el-row>
</template>

<script>
import bus from '@/utils/eventBus'
export default {
    name: '',
    /*props: {
        initdata: {
            type: Array,
            default: function () {
                return []
            }
        }
    },*/
    data() {
        return {
            tabs: [
                // {name: 'SYS-USER',label:'用户管理'}
            ],
            activeName: null
        }
    },
    methods: {
        handleClick(tab, event){
            console.log('tab点击', tab.name, event)
            this.activeName = tab.name
            this.$router.push({ name: tab.name })
        },
        addTab(val){
            let i = -1
            this.tabs.forEach((tab, index )=> {
                if(tab.name === val.name){
                    i=index
                    tab = val
                }
            })
            if(i === -1){
                this.tabs.push({label: val.label, name: val.name})
            }
            this.activeName = val.name
            this.$router.push({ name: val.name,
                query: val.query/*,
                path: val.path,
                */ })
            this.$store.dispatch('tagsView/addView', val)
        },
        handleRemove(targetName){
            let tabs1 = this.tabs
            let activename = this.activeName
            if(this.activeName === targetName) {
                tabs1.forEach((tab, index) => {
                    if(tab.name === targetName) {
                        let nextTab = tabs1[index+1] || tabs1[index-1]
                        if(nextTab) {
                            activename = nextTab.name
                        }
                    }
                })
            }

            this.$store.dispatch('tagsView/delView', {name:targetName}).then(() => {
                //console.log('关闭tab',targetName,this.$store.state.tagsView.cachedViews)
                this.activeName = activename
                this.tabs = this.tabs.filter(tab => tab.name !== targetName)
                this.$router.push({ name: activename })
            })
        },
        handleElse(){
            this.tabs = this.tabs.filter(tab => tab.name === this.activeName)
            this.$store.dispatch('tagsView/delOthersViews',{name:this.activeName})
            //console.log('关闭其他')
        },
        handleLeft(){
            let tabs1 = this.tabs
            let i = 0
            tabs1.forEach((tab, index) => {
                if(tab.name === this.activeName) {
                    i=index
                }
            })
            this.tabs = this.tabs.filter((tab,index) => index>=i)
            this.$store.dispatch('tagsView/delLeftViews',{name:this.activeName,i:i})
            //console.log('关闭左侧所有')
        },
        handleRight(){
            let tabs1 = this.tabs
            let i = 0
            tabs1.forEach((tab, index) => {
                if(tab.name === this.activeName) {
                    i=index
                }
            })
            this.tabs = this.tabs.filter((tab,index) => index<=i)
            this.$store.dispatch('tagsView/delRightViews',{name:this.activeName,i:i})
            //console.log('关闭右侧所有')
        },
        handleCommand(command) {
            if (command === 'else') {
                this.handleElse()
            }
            if (command === 'left') {
                this.handleLeft()
            }
            if (command === 'right') {
                this.handleRight()
            }
        },
    },
    computed:{
        colspan: function() {
            if(this.tabs.length>1){
                return 22
            }
            return 24
        }
    },
    created() {
        bus.$on('share', val => {
            this.addTab(val)
        })
        // console.log(this.$route)
        // console.log(this.$router)
    }
}
</script>

<style scoped>

</style>
